import { useMemo } from 'react';
import {
    canRegisterBusiness,
    isBloggerBusiness,
    isBusinessAdmin,
} from '../../../../utils/accessService';
import { useIsMobile } from '../../../../utils/getIsMobile';
import { useTranslation } from '../../../../utils/useTranslation';
import { IconKebab } from '../../../icon/IconKebab';
import { IconButton } from '../../../input/IconButton';
import { Menu, MenuItem } from '../../../navigation/Menu';
import { Typography } from '../../../typography/Typography';
import { ContextMenuProps } from '../types';

export const ContextMenu = ({ business, user, isCoverVisible, onReport }: ContextMenuProps) => {
    const isMobile = useIsMobile();
    const t = useTranslation();
    const isBlogger = isBloggerBusiness(business.type);

    const canRegister = canRegisterBusiness(user?.businessRegistrationStatus);
    const isAdmin = isBusinessAdmin(business.id, user);
    const contextMenuEnabled = (!isAdmin || canRegister) && !isMobile;

    const trigger = isCoverVisible ? (
        <IconButton variant="filled">
            <IconKebab />
        </IconButton>
    ) : (
        <IconKebab size={16} color="var(--color-primary)" />
    );

    const menuItems = useMemo(() => {
        const result = [];

        if (canRegister && !isBlogger) {
            result.push(
                <MenuItem onClick={() => window.open(`${process.env.REACT_APP_REGISTRATION_LINK}`)}>
                    <Typography>{t('Подтвердить права на профиль')}</Typography>
                </MenuItem>,
            );
        }

        if (!isAdmin) {
            result.push(
                <MenuItem onClick={onReport}>
                    <Typography noWrap color="error">
                        {t('Пожаловаться')}
                    </Typography>
                </MenuItem>,
            );
        }

        return result;
    }, [canRegister, isAdmin, isBlogger, onReport, t]);

    if (!contextMenuEnabled || menuItems.length === 0) {
        return null;
    }

    return (
        <Menu minHeight={24} pt={isCoverVisible ? 1 : 0} pr={1} trigger={trigger}>
            {menuItems}
        </Menu>
    );
};
